/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { scrollToTop } from "../constent/helper";

export const BottomSecton = () => {
  const { isLogin } = useSelector((state) => state.authSlice);

  return (
    <div className="footer-cta">
      <div className="footer-cta__content Footerhome-container">
        <h2 className="md:text-5xl font-bold sm:text-3xl text-xl text-center !text-white !font-roboto">
          Become Part of a Movement That Cares
        </h2>
        <div className="sm:mt-2 mt-1 sm:text-base text-sm !text-white !font-roboto">
          At KWF, your contribution isn't just treated as charity; it's a
          gateway to building a better Pakistan. By taking action today, you can
          help a struggling family survive, educate children, or ensure someone
          gets the healthcare they deserve.
        </div>
        <div className="footer-cta__actions">
          <div className="perfect-match__actions">
            <Link
              className="primary-button !py-8"
              data-track-cta="Find a designer"
              to="/donation"
              onClick={()=>scrollToTop()}
            >
              Donate Now and Transform Lives
            </Link>
          </div>
        </div>

        <div className={`footer-cta__copy text-white`}>
          Register your family
          {isLogin ? (
            <></>
          ) : (
            <>
              <Link to="/login">
                <b>? Login</b>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
